'use strict'

export class rotator {
  constructor(rotatorElement, delay = 3000) {
    this.rotatorElement = rotatorElement
    this.delay = delay
    this.initListeners()
  }

  get rotatorItems() {
    if (!this.rotatorElement) return false
    return this.rotatorElement.querySelectorAll('.rotator-item')
  }

  get activeItem() {
    if (!this.rotatorElement) return false
    return this.rotatorElement.querySelector('.rotator-item:not(.hidden, .hiding)')
  }

  get nextItem() {
    if (!this.rotatorElement) return false
    return this.rotatorElement.querySelector('.rotator-item:not(.hidden, .hiding) + span') || this.rotatorItems[0];
  }

  get hidingItem() {
    if (!this.rotatorElement) return false
    return this.rotatorElement.querySelector('.rotator-item.hiding') || false
  }


  hideElement(element) {
    element.classList.add('hiding')
  }

  resetElement(element) {
    element.classList.remove('hiding')
    element.classList.add('hidden')
  }

  activateElement(element) {
    element.classList.remove('hidden')
  }

  setRotatorInlineHeight(activatedElement) {
    this.rotatorElement.style.setProperty('--rotator-text-height', `${activatedElement.getBoundingClientRect().height}px`)

  }

  startAnimationCircle() {
    const activeItem = this.activeItem
    const nextItem = this.nextItem
    const hidingItem = this.hidingItem

    this.hideElement(activeItem)
    this.activateElement(nextItem)
    this.setRotatorInlineHeight(nextItem)
    if (hidingItem) this.resetElement(hidingItem)

    setTimeout(() => this.startAnimationCircle(), this.delay)
  }

  initListeners() {
    if (!this.rotatorElement) return false
    setTimeout(() => this.startAnimationCircle(), this.delay)
  }
}
